"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IQueryRegistry__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "version",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "createQueryProject",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "isIndexingAvailable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "isOffline",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_address",
                type: "address",
            },
        ],
        name: "numberOfIndexingDeployments",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_blockheight",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "_mmrRoot",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "reportIndexingStatus",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "startIndexing",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "stopIndexing",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "queryId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "version",
                type: "bytes32",
            },
        ],
        name: "updateDeployment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "updateIndexingStatusToReady",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "queryId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
        ],
        name: "updateQueryProjectMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IQueryRegistry__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IQueryRegistry__factory = IQueryRegistry__factory;
IQueryRegistry__factory.abi = _abi;
